import { getDecimalSeparator, numberFormat } from '@libs/utils';

const isFirstCharNumber = (str: string) => /^\d/.test(str);

export const getFormattedValue = (amount: string): string => {
    const formatedNumber = numberFormat(amount, 2) as string;
    const regex = /[,.]0?$/;
    const zeroIndexFormatted = regex.test(amount);
    const defaultDecimal = getDecimalSeparator();
    if (zeroIndexFormatted && formatedNumber !== defaultDecimal) {
        const lastSymbol = amount.slice(-1);
        return `${formatedNumber}${defaultDecimal}${lastSymbol === '0' ? '0' : ''}`;
    }
    return formatedNumber;
};
export const getClearValue = (value: string, prevValue: string) => {
    const trimValue = value.trim();
    const defaultDecimal = getDecimalSeparator();
    const hasZeroInStartPosition = trimValue?.startsWith('0');
    if (hasZeroInStartPosition) {
        const valueWithoutZero = trimValue.slice(1).trim();
        const numericValue = valueWithoutZero.replace?.(/\D/g, '').trim();
        return isFirstCharNumber(valueWithoutZero) ? numericValue : `${defaultDecimal}${numericValue}`;
    }
    const initialValue = trimValue;
    try {
        let clearValue;
        const splitRegex = new RegExp(`[${defaultDecimal}.](?=[0-9]{0,2}.?$)`);
        const digitRegex = /\D/g;
        const valueArr = initialValue.split(splitRegex);
        const integerValue = valueArr?.[0].replace(digitRegex, '').replace(/^0/, '');
        if (valueArr?.length > 1) {
            const decimalValue = valueArr[1]?.replace(digitRegex, '') ?? '';
            clearValue = `${integerValue}.${decimalValue.slice(0, 2)}`;
        } else if (valueArr.length === 1 && prevValue === '0') {
            clearValue = integerValue.replace(/0$/, '');
        } else {
            clearValue = integerValue;
        }
        if (initialValue?.length === 0 || clearValue?.length === 0) {
            clearValue = '0';
        }
        if (clearValue) {
            return clearValue;
        }
        return initialValue;
    } catch {
        return initialValue;
    }
};
export const toFixedSum = (sum?: string) => {
    if (sum) {
        return Number(sum).toFixed(2);
    }
    return '';
};
export const sanitiseServerValue = (value: string): string => {
    try {
        if (value && value.length > 0 && Number.isNaN(Number(value))) {
            const decimal = getDecimalSeparator();
            const regex = new RegExp(`[^0-9${decimal}-]`, 'g');
            return value.replace(regex, '').replace(decimal, '.');
        }
        return value;
    } catch (e) {
        console.warn(e, 'SanitiseServerValue error');
        return value;
    }
};
